import { useConnection } from 'hooks/useConnection'
import { useMemo } from 'react'
import { Trade } from 'state/routing/trades'

interface SwapCall {
  address: string
  calldata: string
  value: string
}

/**
 * Returns the swap calls that can be used to make the trade
 * @param trade trade to execute
 * @param recipientAddress the address of the recipient of the swap output
 * @param selectedTradeOption
 */
export function useSwapCallArguments(
  trade: Trade | undefined,
  recipientAddress: string | null | undefined
): SwapCall[] {
  const { account, chainId, wagmiWalletClient } = useConnection()
  const recipient = recipientAddress === null ? account : recipientAddress

  return useMemo(() => {
    if (!trade || !recipient || !wagmiWalletClient || !account || !chainId) return []

    if (trade.methodParameters) {
      return [
        {
          address: trade.methodParameters.to,
          calldata: trade.methodParameters.calldata,
          value: trade.methodParameters.value,
        },
      ]
    }

    return []
  }, [account, chainId, wagmiWalletClient, recipient, trade])
}
